import React, { useState } from 'react';
import axios from "axios";

import SvgIcon from "../../SharedComponents/Icons";

import './index.sass';


const ContactInfo = ({ classes, email, iconSize, phone, placeId, websiteUrl }) => {

  const [showContacts, setShowContacts] = useState(false);

  const toggleContactInfo = () => {
    if (!showContacts) {
      const url = '/api/frontend/custom_events';
      const params = {
        name: 'fact_sheet_flipped',
        payload: {
          place_id: placeId,
          url: window.location.href,
        }
      };

      setShowContacts(true);

      axios
        .post(url, params, { headers: { 'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content }})
        .catch(error => { console.log('Error: ', error) });
    }
  };


  return (
    <div className={`contact-info ${classes || ''}`}>

      <h2 className="detail-view__section-header">Kontaktoplysninger</h2>

      { email &&
        <div className="contact-info__link-wrapper">
          <SvgIcon name="email" size={24} />
          { showContacts
            ? <a className="contact-info__link" href={`mailto: ${email}`}>{ email }</a>
            : <div className="contact-info__link inactive" onClick={toggleContactInfo}>Vis email</div>
          }
        </div>
      }

      { phone &&
        <div className="contact-info__link-wrapper">
          <SvgIcon name="phone" size={24} />
          { showContacts
            ? <a className="contact-info__link phone" href={`tel://${phone}`}>{ phone }</a>
            : <div className="contact-info__link inactive" onClick={toggleContactInfo}>Vis telefonnummer</div>
          }
        </div>
      }

      { websiteUrl &&
        <div className="contact-info__link-wrapper">
          <SvgIcon name="website_link" size={24} />
          <a className="contact-info__link" href={websiteUrl} target="_blank">Besøg hjemmeside</a>
        </div>
      }

    </div>
  )
};

export default ContactInfo;
